import { render, staticRenderFns } from "./SubscribePrice.vue?vue&type=template&id=5006d088&scoped=true&"
import script from "./SubscribePrice.vue?vue&type=script&lang=js&"
export * from "./SubscribePrice.vue?vue&type=script&lang=js&"
import style0 from "./SubscribePrice.vue?vue&type=style&index=0&id=5006d088&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5006d088",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SubscribePriceReseller: require('/opt/render/project/src/channels2022/src/components/subscribe/price/SubscribePriceReseller.vue').default,SubscribePricesCards: require('/opt/render/project/src/channels2022/src/components/subscribe/price/SubscribePricesCards.vue').default,SubscribeBtn: require('/opt/render/project/src/channels2022/src/components/subscribe/price/SubscribeBtn.vue').default})
